import getApi from '../../api'
import {
  AnswerInstanceMutationPayload,
  AnswerInstanceResource,
} from './mapper/answerInstance.model'

export const createAnswerInstance = (answerInstance: AnswerInstanceMutationPayload) =>
  getApi().post<AnswerInstanceResource>('/answer_instances', answerInstance)
